import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { UserService } from 'app/services/user.service';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { PopoverDirective, ModalDirective } from 'ng-uikit-pro-standard';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';


@Component({
    selector: 'reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})

export class ResetPasswordComponent implements OnInit {
    resetForm: FormGroup;
    token: string;
    email: string;
    fqdn: string;
    forgetpasswordmsg: string;
    icon: string;
    canRedirect: boolean = false;
    showLoader: boolean = false;
    matcher: any;
    @ViewChild('forgetpasswordpopover', { static: true }) forgetpasswordpopover: ModalDirective;



    constructor(private activatedRoute: ActivatedRoute, private userService: UserService, private formBuilder: FormBuilder,
        private _validationHandler: ValidationHandler, private router: Router,private ecoDocsTitleService: EcoDocsTitleService) {
        this.resetForm = this.formBuilder.group({
            password: ['', Validators.required],
            password_confirmation: [''],
        }, { validator: this.checkPasswords });

        this.activatedRoute.queryParams.subscribe((queryParams) => {
            this.token = queryParams.token;
            this.email = queryParams.email;
            this.fqdn = queryParams.fqdn;
            });

    }

    ngOnInit() {
        this.ecoDocsTitleService.setTitle('Reset Password', false);
    }

    checkPasswords(group: FormGroup) {
        let pass = group.get('password').value;
        let confirmPass = group.get('password_confirmation').value;
        return pass === confirmPass ? null : ["Passwords don't match."]

    }

    resetPassword() {

        if (this.resetForm.invalid) {
            debugger;
            this._validationHandler.onSubmitCheck(this.resetForm);
            return;
        }
        this.showLoader = true;

        this.userService.resetPassword(this.token, this.resetForm.value.password, this.resetForm.value.password_confirmation, this.email, this.fqdn).subscribe(res => {
            this.forgetpasswordmsg = "Password set successfully!";
            this.icon = "fa fa-check text-success";
            this.canRedirect = true;
            this.showLoader = false;

            this.forgetpasswordpopover.show();

        }, err => {
            this.forgetpasswordmsg = err.message;
            this.icon = "fa text-white fa-times-circle text-danger";
            this.canRedirect = false;
            this.showLoader = false;

            this.forgetpasswordpopover.show();

        });

    }
    redirect() {
        if (this.canRedirect)
            this.router.navigate(['/login']);
        else
            this.forgetpasswordpopover.hide();

    }


}
